import { SvgIcon } from "@mui/material"

import MemberLevelIcon from "@/assets/icons/membershipSnowflakes"

export const getMemberLevelIcon = (memberLevelKey: string): React.ReactNode => {
  const SvgComponent = MemberLevelIcon[memberLevelKey]
  if (!SvgComponent) return null

  return (
    <SvgIcon
      component={SvgComponent}
      inheritViewBox
      aria-hidden="true"
      sx={{
        width: 16,
        height: 16,
      }}
    />
  )
}
